import { DefaultService } from '@/services/DefaultService';

/* @71147 */
export default class AgroAssNivelTecnologicoProdutoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(column, order, page, limit, situacao, idagroniveltecnologico, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/agro-niveltecnologico/agroassniveltecnologicoproduto.json?page=${page}&limit=${limit}&column=${column}&order=${order}&situacao=${situacao}&idagroniveltecnologico=${idagroniveltecnologico}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/agro/agro-niveltecnologico/agroassniveltecnologicoproduto/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(assniveltecnologicoproduto) {
        return this._http.post(`${this._env}/agro/agro-niveltecnologico/agroassniveltecnologicoproduto/updatesituacao`, assniveltecnologicoproduto, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    findNaoAssociados(column, order, page, limit, idagroniveltecnologico, ...params) {
        return this._http.get(encodeURI(`${this._env}/agro/agro-niveltecnologico/agroassniveltecnologicoproduto/naoassociados?page=${page}&limit=${limit}&column=${column}&order=${order}&idagroniveltecnologico=${idagroniveltecnologico}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    save(lista) {
        return this._http.post(`${this._env}/agro/agro-niveltecnologico/agroassniveltecnologicoproduto`, lista, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    saveSingle(obj) {
        return this._http.post(`${this._env}/agro/agro-niveltecnologico/agroassniveltecnologicoproduto/insertsingle`, obj, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}